import { Button, ButtonProps } from '@mui/material';
import { withLoader } from 'ui/hoc/withLoader';

export const LoadingButton = withLoader<ButtonProps>(Button);
